import {Record as record} from 'immutable';

export default record(
    {
        reviewCount: null,
        averageRating: null,
        oneStarReviewCount: null,
        twoStarReviewCount: null,
        threeStarReviewCount: null,
        fourStarReviewCount: null,
        fiveStarReviewCount: null,
        filter: null,
        ownershipTransferred: false,
        paging: {
            page: 1,
            pageSize: 10,
            totalPages: 1,
            totalResults: null
        },
        ownerRating: {},
        reviews: [],
        isFetching: false,
        previewCount: 3,
        reviewId: '',
        scrollTop: false,
        pageIndex: 1,
        errorFetchingReviews: false,
        translatedReviewsMap: {},
        fetchAutoTranslatedReviews: false
    },
    'ReviewsRecord'
);
